module.exports = __webpack_public_path__ + "479c31759042a1d88980e126129585da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tobacco-pie-chart.png
// module id = 1554
// module chunks = 0